(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dropmagic-style"]) return;
  try {
    

(function patchBodyClass() {
  if (document.body) {
    document.body.classList.add('theme__modal--callback');
  } else {
    setTimeout(patchBodyClass, 10);
  }
})();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        const faqItems = document.querySelectorAll('.faq-item');
        faqItems.forEach(item => {
            const question = item.querySelector('.faq-question');
            const answer = item.querySelector('.faq-answer');
            question.addEventListener('click', function() {
                faqItems.forEach(i => {
                    if (i !== item) {
                    i.classList.remove('active');
                    }
                });
                item.classList.toggle('active');
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
      const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
      if (!isIOS) {
        testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        testimonialConfig.freeMode = true;
      }
      new Swiper(testimonialEl, testimonialConfig);
    }

    if( document.querySelectorAll('.pdp__productFaq_widget__question').length > 0 ){
      document.querySelectorAll('.pdp__productFaq_widget__question').forEach((el)=>{
          el.addEventListener('click', (target)=>{
              target.preventDefault();
              target.target.closest('.pdp__productFaq_widget__item').classList.toggle('active');
          })
      })
    }
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
      document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
        })
      });
      document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
        })
      });
    }
  });

  document.addEventListener("shopify:section:load", () => {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
      const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
      if (!isIOS) {
        testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        testimonialConfig.freeMode = true;
      }
      new Swiper(testimonialEl, testimonialConfig);
    }

    if( document.querySelectorAll('.pdp__productFaq_widget__question').length > 0 ){
      document.querySelectorAll('.pdp__productFaq_widget__question').forEach((el)=>{
          el.addEventListener('click', (target)=>{
              target.preventDefault();
              target.target.closest('.pdp__productFaq_widget__item').classList.toggle('active');
          })
      })
    }
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
      document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
        })
      });
      document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
        })
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', ()=>{
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const testimonialEl = document.querySelector('.Testimonial__reviews_interior.swiper');
    if (testimonialEl) {
      const testimonialConfig = { spaceBetween: 12, slidesPerView: 'auto', grabCursor: true };
      if (!isIOS) {
        testimonialConfig.mousewheel = { forceToAxis: true, thresholdDelta: 35 };
        testimonialConfig.freeMode = true;
      }
      new Swiper(testimonialEl, testimonialConfig);
    }

    if( document.querySelectorAll('.pdp__productFaq_widget__question').length > 0 ){
      document.querySelectorAll('.pdp__productFaq_widget__question').forEach((el)=>{
          el.addEventListener('click', (target)=>{
              target.preventDefault();
              target.target.closest('.pdp__productFaq_widget__item').classList.toggle('active');
          })
      })
    }
    if( document.querySelectorAll('.video__playIcon').length > 0 ){
      document.querySelectorAll('.video__playIcon .action--pause').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--play').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').pause();
        })
      });
      document.querySelectorAll('.video__playIcon .action--play').forEach((elm)=>{
        elm.addEventListener('click', (target)=>{
          target.preventDefault();
          target.currentTarget.classList.add('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('.action--pause').classList.remove('hidden');
          target.target.closest('.Testimonial__video_tagged').querySelector('video').play();
        })
      });
    }

    function isInViewport(elem) {
      const rect = elem.getBoundingClientRect();
      return (
        rect.bottom >= 0 &&
        rect.right >= 0 &&
        rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.left <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    const stickyBar = document.querySelector('.PDP__stk__mainwrapper');
    const header = document.querySelector('.section-header');
    const headerHeight = header ? header.clientHeight : 0;
    const addToCartElements = document.querySelectorAll('[js-scroll-identity]');
    const footerSections = document.querySelectorAll('.shopify-section-group-footer-group');

    function shouldHideSticky() {
      for (const el of [...addToCartElements, ...footerSections]) {
        if (el && isInViewport(el)) return true;
      }
      return false;
    }

    function handleStickyScroll() {
      const scrollY = window.scrollY;
      const triggerElement = document.querySelector('[js-scroll-identity]');
      if (!triggerElement || !stickyBar) return;
      const triggerOffset = triggerElement.offsetTop;
      if (scrollY > triggerOffset) {
        if (shouldHideSticky()) {
          stickyBar.classList.remove('active');
        } else {
          stickyBar.classList.add('active');
        }
      } else {
        stickyBar.classList.remove('active');
      }
    }
    window.addEventListener('scroll', handleStickyScroll, { passive: true });

    document.querySelector('.PDP__stk__actionbtn')?.querySelector('.product-form__submit')?.addEventListener('click',(tg)=>{
      tg.preventDefault();
      document.querySelector('.product-form__buttons')?.querySelector('.product-form__submit')?.click();
    })

  })

  } catch(e) { console.error(e); }
})();
})();
